/**
 * Slug normalisation for public URL slugs (help center slug, article slug).
 *
 * TWO functions, deliberately. A rule that is correct for a FINAL value is
 * wrong for an INTERMEDIATE one: a trailing hyphen is invalid to SAVE, but it
 * is a perfectly normal thing to have typed SO FAR.
 *
 * 🚨 The trap this exists to prevent: normalising strictly on every keystroke
 * strips the trailing hyphen the instant it is typed, so `spago` + `-` snaps
 * straight back to `spago`. A hyphen can never survive being typed, and the
 * field only ever accepts a single word — `spago-shopper` becomes literally
 * untypeable. Use `slugifyTyping` in `onChange`, `slugifyStrict` on blur and
 * before save.
 */

/** While typing. Permissive: KEEPS leading/trailing hyphens so the user can
 *  type through them, and never trims. Still lowercases, maps invalid
 *  characters to `-`, and collapses runs, so the value can't go out of range. */
export const slugifyTyping = (str: string): string =>
  str
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/-{2,}/g, '-');

/** On blur, before save, and for any value derived from a finished string
 *  (e.g. an agent/article name). The full rule the server validates against:
 *  additionally strips leading/trailing hyphens. Behaviour-identical to the
 *  old single `slugify` for final values. */
export const slugifyStrict = (str: string): string =>
  slugifyTyping(str).replace(/^-+|-+$/g, '');
